<template>
  <v-app id="app">
    <v-main>
      <SideBar v-if="$route.fullPath != '/admin/login'" />
      <div
        :class="[
          $route.fullPath != '/admin/login' ? 'router-wrapper' : null,
          $vuetify.rtl ? 'rtl' : null,
        ]"
      >
        <router-view />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { Store } from "@/store/auth";
export default {
  data: () => ({
    Store,
  }),
  components: {
    SideBar: () => import("@/components/SideBar.vue"),
  },
  methods: {
    checkLang() {
      const lang = localStorage.getItem("dmlang");
      lang ? (this.$i18n.locale = lang) : "en";
      lang && lang == "ar"
        ? (this.$vuetify.rtl = true)
        : (this.$vuetify.rtl = false);
    },
    logOut() {
      Store.logout();
    },
  },
  created() {
    this.checkLang();
    if (localStorage.getItem("userAbilities") === null) {
      //  alert('you must go to log in page')
      this.logOut();
    }
  },
};
</script>

<style lang="scss">
@import url("@/assets/style/global-variable.css");
@import url("https://fonts.googleapis.com/css2?family=Tajawal:wght@200;300;400;500;700;800;900&display=swap");
#app {
  font-family: "Tajawal", sans-serif;
  color: var(--black);
}
.v-application p {
  margin-bottom: 3px !important;
}
nav {
  a {
    font-weight: bold;
    color: var(--white) !important;
    text-decoration: none;
    text-align: center;
    padding: 15px 10px;
    display: block;
    width: 100%;

    &.router-link-exact-active {
      color: var(--black) !important;
      background-color: var(--white);
      border-radius: 5px;
    }
  }
}

.router-wrapper {
  margin-left: 250px;
  padding: 20px 20px;
  // overflow-x: auto;
  min-height: 100vh;
  width: calc(100vw - 250px);
}
.router-wrapper.rtl {
  margin-right: 250px;
}

@media screen and (max-width: 768px) {
  .router-wrapper {
    margin-left: 0px;
    width: calc(100vw);
  }
  .router-wrapper.rtl {
    margin-right: 0px;
  }
}

.v-toast__item .v-toast__item--error .v-toast__item--top-right {
  flex-direction: row-reverse !important;
}

.v-toast__item {
  max-width: 70% !important;
  flex-direction: row-reverse !important;
}

.v-toast__text {
  direction: rtl !important;
  padding: 0.2em 0.5em !important;
  font-family: "Tajawal", sans-serif !important;
}

.v-toast__item .v-toast__text {
  padding: 0.5em 1em !important;
  font-size: 15px !important;
}

.v-toast__icon {
  margin-left: 0.5em !important;
  margin-right: 1em !important;
}
.titlee {
  color: var(--primary);
  font-size: 1.5vw;
}
</style>
